<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
    fullscreen
  >
    <div class="mt-2 w-full vx-row justify-between">
      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>User :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="userObj !== null ? 'color: black;' : 'color: red;'"
                >{{ userObj !== null ? userObj.name : "User Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>NIK :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.nik !== null ? 'color: black;' : 'color: red;'"
                >{{ formData.nik !== null ? formData.nik : "NIK Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kontak :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.handphone !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.handphone !== null ? formData.handphone : "No. Telepon Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Tanggal Lahir :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.tanggal_lahir !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.tanggal_lahir !== null
                    ? formData.tanggal_lahir
                    : "Tanggal Lahir Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Tempat Lahir :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.tempat_lahir !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.tempat_lahir !== null
                    ? formData.tempat_lahir
                    : "Tempat Lahir Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Jumlah Kebutuhan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  formData.jumlah_kebutuhan !== null ? 'color: black;' : 'color: red;'
                "
                >{{
                  formData.jumlah_kebutuhan === null
                    ? "Jumlah Kebutuhan Kosong"
                    : formData.jumlah_kebutuhan | toCurrency
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Deskripsi Kebutuhan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span class="text-lg">{{
                formData.deskripsi_kebutuhan !== null ? formData.deskripsi_kebutuhan : "-"
              }}</span>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Jenis Kelamin :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.jenis_kelamin !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.jenis_kelamin !== null
                    ? formData.jenis_kelamin === 1
                      ? "Laki-laki"
                      : "Perempuan"
                    : "Jenis Kelamin Tidak Diisi"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Pekerjaan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.pekerjaan !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.pekerjaan !== null ? formData.pekerjaan : "Pekerjaan Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Alamat :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-lg"
                :style="formData.alamat !== null ? 'color: black;' : 'color: red;'"
                >{{ formData.alamat !== null ? formData.alamat : "Alamat Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Keterangan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-lg"
                :style="formData.keterangan !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.keterangan !== null ? formData.keterangan : "Keterangan Kosong"
                }}</span
              >
            </section>
          </div>
        </main>
      </section>

      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Foto KTP</strong></h6>
              <!-- <span class="text-danger">*</span> -->
            </section>
            <div class="gap-4 items-center mb-4">
              <img
                :src="
                  formData.file_ktp !== emptyImage
                    ? formData.file_ktp.includes('upload//')
                      ? `${url.baseFl}/${formData.file_ktp}`
                      : formData.file_ktp
                    : formData.file_ktp
                "
                alt="file-kantor-img"
                class="rounded-lg shadow-md cursor-pointer block mb-4 w-full"
              />
              <div>
                <input
                  type="file"
                  class="hidden"
                  ref="updateImg"
                  @change="updateCurrFileKTP"
                  accept="image/*"
                />
                <a
                  v-if="formData.file_ktp !== emptyImage"
                  :href="
                    formData.file_ktp !== emptyImage
                      ? formData.file_ktp.includes('upload//')
                        ? `${url.baseFl}/${formData.file_ktp}`
                        : formData.file_ktp
                      : formData.file_ktp
                  "
                  target="_blank"
                  >Download Foto KTP</a
                >
                <p v-else style="color: red">Foto KTP tidak ada</p>
                <!-- <vs-button
              class="mr-4 sm:mb-0 mb-2"
              @click="$refs.updateImg.click()"
              >Download Foto Kantor</vs-button
            > -->
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
          </div>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Evidence</strong></h6>
              <!-- <span class="text-danger">*</span> -->
            </section>
            <div class="flex justify-start w-full gap-4 items-center mb-4">
              <vs-icon
                v-if="formData.file_evidence === null"
                icon="attach_file"
                size="medium"
                color="grey"
                bg="white"
                rounded
              ></vs-icon>
              <div
                v-else
                class="rounded-lg shadow-md bg-grey cursor-pointer block mb-4 p-6 place-items-center"
              >
                <h2>
                  <strong>{{
                    binaryFileEvidance !== ""
                      ? binaryFileEvidance.name.split(".").slice(-1)[0]
                      : formData.file_evidence !== null
                      ? formData.file_evidence.split(".").slice(-1)[0]
                      : ""
                  }}</strong>
                </h2>
              </div>
              <div>
                <p class="text-black text-sm mb-2" v-if="formData.file_evidence !== null">
                  {{
                    binaryFileEvidance !== ""
                      ? binaryFileEvidance.name.split("/").slice(-1)[0]
                      : formData.file_evidence !== null
                      ? formData.file_evidence.split("/").slice(-1)[0]
                      : "Tidak ada file evidence"
                  }}
                </p>
                <p v-else class="text-sm mb-2" style="color: red">
                  Tidak ada file evidence
                </p>
                <a
                  v-if="formData.file_evidence !== null"
                  :href="`${url.baseFl}/${formData.file_evidence}`"
                  target="_blank"
                  >Download File Evidence</a
                >
                <!-- <input
              type="file"
              class="hidden"
              ref="updateSK"
              @change="updateCurrFileSK"
              accept=".pdf,.doc,.docx,.xls,.ppt,.pptx,.png,.jpeg,.jpg,.txt,.zip,.rar,.z7,.gz"
            /> -->
                <!-- <vs-button
              class="mr-4 sm:mb-0 mb-2"
              @click="$refs.updateSK.click()"
              >Download File SK</vs-button
            > -->
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
          </div>
          <div>
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>ACC Kebutuhan (Rp) :</strong></h6>
            </section>
            <vs-input
              @keypress="onlyNumber"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="acc_kebutuhan"
              class="w-full sidebar-input"
              v-model="nominal"
              placeholder="Isi Dengan Jumlah Uang yang Diterima PM"
            />
            <span class="text-danger text-sm">{{
              formData.acc_kebutuhan == "0"
                ? "Uang kebutuhan yang ingin di acc harus lebih dari 0"
                : errors.first("acc_kebutuhan")
            }}</span>
          </div>
        </main>
      </section>
      <!-- <div class="vx-col w-full mb-8">
        <p class="mb-4 flex justify-end"><strong>Aproval Sahabat ZX</strong></p>
        <div class="flex justify-end gap-2">
          <p>{{ statusUser ? "Disetujui" : "Tidak Disetujui" }}</p>
          <vs-switch
            :color="statusUser ? 'success' : 'danger'"
            v-model="statusUser"
          />
        </div>
      </div> -->
    </div>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="addWithOption(2)"
          >Tidak Disetujui</vs-button
        >
        <vs-button color="success" class="ml-2 rounded-2xl" @click="addWithOption(1)"
          >Disetujui</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import url from "@/url.js";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    acc_kebutuhan: {
      required: "Harap isi acc kebutuhan penerima manfaat!",
    },
  },
};

Validator.localize("en", dict);

export default {
  components: {
    VuePhoneNumberInput,
    Validator,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      binaryFileEvidance: "",
      binaryFileKTP: "",
      kabkotList: [],
      kelamin: [
        {
          id: 1,
          text: "Laki-laki",
        },
        {
          id: 2,
          text: "Perempuan",
        },
      ],
      aproval: [
        {
          id: 1,
          text: "Disetujui",
        },
        {
          id: 2,
          text: "Belum Disetujui",
        },
      ],
      stLembagaObj: null,
      stUpzOBj: null,
      userObj: null,
      npwp: null,
      fax: null,
      zakat_perbulan: null,
      no_pengukuhan: null,
      statusUser: false,
      formData: {
        fitur_id: null,
        status: null,
        status_identity: null,
        status_aproval: null,
        user_id: null,
        jumlah_kebutuhan: null,
        acc_kebutuhan: null,
        deskripsi_kebutuhan: "",
        nik: null,
        tempat_lahir: "",
        tanggal_lahir: "",
        handphone: null,
        jenis_kelamin: null,
        pekerjaan: "",
        keterangan: "",
        alamat: "",
        file_evidence: null,
        file_ktp: emptyImage,
      },
    };
  },
  computed: {
    nominal: {
      get() {
        return this.formatRupiah(this.formData.acc_kebutuhan);
      },
      set(val) {
        // Do something with the val here...
        this.formData.acc_kebutuhan = val;
      },
    },
    provinsiList() {
      return this.$store.state.wilayah.provinsiList;
    },
    provinsiSelect() {
      return this.formData.provinsi_id;
    },
    userCompute() {
      return this.formData.user_id;
    },
    titlePopUp() {
      return this.passData != null ? "Edit Penerima Manfaat" : "Tambah Penerima Manfaat";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.userObj = this.passData.user;
        this.formData.fitur_id = this.passData.fitur_id;
        this.formData.status = this.passData.status;
        this.formData.status_identity = this.passData.status_identity;
        this.formData.user_id = this.passData.user.id;
        this.formData.status_aproval = this.passData.status_aproval;
        this.formData.jumlah_kebutuhan = this.passData.jumlah_kebutuhan;
        this.nominal = this.passData.acc_kebutuhan
          ? this.passData.acc_kebutuhan.toString()
          : null;
        this.formData.deskripsi_kebutuhan = this.passData.deskripsi_kebutuhan;
        this.formData.nik = this.passData.nik;
        this.formData.tempat_lahir = this.passData.tempat_lahir;
        this.formData.tanggal_lahir = this.passData.tanggal_lahir;
        this.formData.handphone = this.passData.handphone;
        this.formData.jenis_kelamin = this.passData.jenis_kelamin;
        this.formData.pekerjaan = this.passData.pekerjaan;
        this.formData.keterangan = this.passData.keterangan;
        this.formData.alamat = this.passData.alamat;
        this.formData.file_evidence =
          this.passData.file_evidence !== null
            ? this.passData.file_evidence.includes(`${this.url.baseFl}/`)
              ? this.passData.file_evidence.split(`${this.url.baseFl}/`)[1]
              : this.passData.file_evidence
            : null;
        this.formData.file_ktp =
          this.passData.file_ktp !== null
            ? this.passData.file_ktp.includes(`${this.url.baseFl}/`)
              ? this.passData.file_ktp.split(`${this.url.baseFl}/`)[1]
              : this.passData.file_ktp
            : this.emptyImage;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.userObj = null;
      this.formData.fitur_id = null;
      this.formData.status = null;
      this.formData.status_identity = null;
      this.formData.user_id = null;
      this.formData.status_aproval = null;
      this.formData.jumlah_kebutuhan = null;
      this.formData.acc_kebutuhan = null;
      this.formData.deskripsi_kebutuhan = "";
      this.formData.nik = null;
      this.formData.tempat_lahir = "";
      this.formData.tanggal_lahir = "";
      this.formData.handphone = null;
      this.formData.jenis_kelamin = null;
      this.formData.pekerjaan = "";
      this.formData.keterangan = "";
      this.formData.alamat = "";
      this.formData.file_evidence = null;
      this.formData.file_ktp = this.emptyImage;
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption(id) {
      this.formData.status_aproval = id;
      this.$validator.validateAll().then((result) => {
        if (result && this.formData.acc_kebutuhan != "0") {
          this.$vs.loading({
            color: "primary",
          });
          this.addData();
        } else {
          if (this.formData.status_aproval === 2) {
            this.formData.acc_kebutuhan = 0;
            this.addData();
          }
        }
      });
    },
    addWithFileKTP() {
      this.$store
        .dispatch("file/addFile", this.binaryFileKTP)
        .then((v) => {
          this.formData.file_ktp = v.link;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addWithFileEvidance() {
      this.$store
        .dispatch("file/addFile", this.binaryFileEvidance)
        .then((v) => {
          this.formData.file_evidence = v.link;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file_ktp === this.emptyImage) {
        this.formData.file_ktp = null;
      }
      this.formData.acc_kebutuhan = this.formData.acc_kebutuhan.split(".", "");
      this.$store
        .dispatch("penyaluran/cudTerimaManfaat", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: this.passData !== null ? "Edit PM Sukses!" : "Tambah PM Sukses!",
            text: this.passData !== null ? `PM Berhasil diedit` : `PM Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
          this.$vs.loading.close();
        });
    },

    updateCurrFileEvidence(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_evidence = e.target.result;
          this.binaryFileEvidance = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrFileKTP(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_ktp = e.target.result;
          this.binaryFileKTP = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 400px;
  max-width: 100%;
  overflow: auto;
}
</style>
